import { Ipagination } from '@/utils';
import actionType from '../actions/promotion/actionType';

export interface TransactionState extends Ipagination {
  ruleList: Array<any>;
  pageLoading: boolean;
}

const initialState: TransactionState = {
  // 列表
  ruleList: [],
  pageLoading: false,
  pageSize: 50,
  pageNum: 1,
  total: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.CLEAR_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SAVE_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_PAGINATION:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_TIME:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.RESET:
      return {
        ...state,
        ...action.payload,
        pageNum: 1,
        pageSize: 50,
        total: 0,
      };
    case actionType.TOGGLE_LOADING: {
      const loading = state[action.payload];
      return {
        ...state,
        [action.payload]: !loading,
      };
    }

    case actionType.RESET_PAGINATION:
      return {
        ...state,
        pageNum: 1,
        pageSize: 50,
        total: 0,
      };
    case actionType.REFUND_PAGE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
